import { useState, useCallback } from 'react';

interface FileViewerState {
  files: string[];
  currentIndex: number;
  isOpen: boolean;
}

/**
 * Хук для управления состоянием просмотрщика файлов.
 * Устраняет дублирование одинаковых useState + хэндлеров во всех страницах.
 */
export const useFileViewer = () => {
  const [state, setState] = useState<FileViewerState>({
    files: [],
    currentIndex: 0,
    isOpen: false,
  });

  const open = useCallback((files: string[], startIndex = 0) => {
    setState({ files, currentIndex: startIndex, isOpen: true });
  }, []);

  const close = useCallback(() => {
    setState({ files: [], currentIndex: 0, isOpen: false });
  }, []);

  const next = useCallback(() => {
    setState((prev) =>
      prev.currentIndex < prev.files.length - 1
        ? { ...prev, currentIndex: prev.currentIndex + 1 }
        : prev
    );
  }, []);

  const prev = useCallback(() => {
    setState((prev) =>
      prev.currentIndex > 0
        ? { ...prev, currentIndex: prev.currentIndex - 1 }
        : prev
    );
  }, []);

  return { ...state, open, close, next, prev };
};
